import { FORM_KEYS } from "repoV2/features/Common/modules/FormData/FormData.constants";
import { IGSTDetails } from "repoV2/features/Common/modules/FormData/interfaces/GSTDetailsFormGroup.interfaces";
import useGetFormData from "repoV2/features/Common/modules/FormData/utils/useGetFormData";
import { checkIsStringEmpty } from "repoV2/utils/common/dataTypes/string";

const useGetBillingStateHelpers = () => {
    const gstDetails =
        useGetFormData<IGSTDetails>({
            key: `${FORM_KEYS.gst_details}`,
        }) || {};

    // If there is no GSTIN, then billing state is not diabled, otherwise it is
    const isBillingStateDisabled = !checkIsStringEmpty(
        gstDetails.registration_number
    );

    return {
        isBillingStateDisabled,
    };
};

export default useGetBillingStateHelpers;
